import { render, staticRenderFns } from "./AddContactModal.vue?vue&type=template&id=03be97cb&"
import script from "./AddContactModal.vue?vue&type=script&lang=js&"
export * from "./AddContactModal.vue?vue&type=script&lang=js&"
import style0 from "./AddContactModal.vue?vue&type=style&index=0&id=03be97cb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports